import React, { Fragment, useContext, useState } from "react";
import GoBackBtn from "../../components/buttons/GoBackBtn";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import ChoosePass from "../../components/passes/ChoosePass";
import Reservation from "../../components/Reservation";
import PaymentForPassModal from "../../components/modals/PaymentForPassModal";

const UseReservation = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [selectedPass, setSelectedPass] = useState(null);
    const [showPaymentForPassModal, setShowPaymentForPassModal] = useState(null);
    const [reloadActivePasses, setReloadActivePasses] = useState(false);

    const changeReservation = async () => {
        const res = await postMethod("/use-reservation", { reserv: showView.params.reserv, upID: selectedPass });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 2000, id: "usedReserv" }]);
            changeView({ nav: "reservations", sub: "reservationsList", params: { moduleName: "APP" } });
        } else setBlockForm(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        //if (!selectedPass && !blockForm) errors.push(t("error.noCheckedPass"));

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.changingReservation") }]);
            setBlockForm(true);
            changeReservation();
        }
    };

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("reservations.useReservation")}</h1>
                        </Col>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Table className="white-table mb-0 p-2 shadow-sm border rounded border-secondary-subtle" size="sm">
                                        <tbody>
                                            <Reservation reserv={showView.params.reserv} onlyDisplay />
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                        <ChoosePass
                            selectedPass={selectedPass}
                            setSelectedPass={setSelectedPass}
                            setFormChanged={setFormChanged}
                            blockForm={blockForm}
                            classID={showView.params.reserv.class_id}
                            onShowPaymentForPassModal={setShowPaymentForPassModal}
                            reloadActivePasses={reloadActivePasses}
                            setReloadActivePasses={setReloadActivePasses}
                        />
                    </Row>
                    <Row className="sticky-bottom bg-light-primary">
                        <Col xs={8}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("changeForSignUp")}
                            </Button>
                        </Col>
                        <Col xs={4} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "reservations", sub: "reservationsList", params: { moduleName: "APP" } })}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>

            {showPaymentForPassModal && (
                <PaymentForPassModal
                    pass={showPaymentForPassModal}
                    onClose={() => setShowPaymentForPassModal(false)}
                    onProceed={() => {
                        setShowPaymentForPassModal(false);
                        setReloadActivePasses(true);
                    }}
                    signUpForClass
                />
            )}
        </Fragment>
    );
};

export default UseReservation;
